import { FieldErrors, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { NotaFiscalProps } from "../types";
import { useEffect, useState } from "react";
import Field from "../../../shared/components/Inputs/Field";
import InputMoney from "../../../shared/components/Inputs/InputMoney";
import { useGetAllContatos } from "../../Contatos/hooks/useGetContatos";
import { LoadingPage } from "../../../shared/components/LoadingPage";
import { AutoComplete } from "../../../shared/components/Inputs/AutoComplete";

interface FormModalProps {
  register: UseFormRegister<any>;
  disabled?: boolean;
  errors?: FieldErrors<any>;
  notaFiscal?: NotaFiscalProps;

  setValue: UseFormSetValue<any>;
  formEdit?: boolean;
  control?: any;
}

interface ContatoOption {
  value: string;
  label: string;
}

export function FormModalNotaFiscal({
  register,
  notaFiscal,
  disabled,
  setValue,
  formEdit,
  control,
  errors,
}: FormModalProps) {
  const { data: contatoData } = useGetAllContatos();
  const [contatoOptions, setContatoOptions] = useState<ContatoOption[]>([]);

  useEffect(() => {
    if (contatoData) {
      const options = contatoData.map((c: any) => ({
        value: c.Id.toString(),
        label: c.Nome,
      }));
      setContatoOptions(options);
    }
  }, [contatoData]);

  return (
    <form>
      {contatoOptions.length === 0 ? <div className="w-[40rem] h-[15rem] flex items-center justify-center"><LoadingPage /></div> :
        <>
          <div className="flex  gap-3">
            <div className="flex flex-col">
              <label htmlFor="ContatoNome">
                Contato
                {contatoOptions.length &&
                  <AutoComplete 
                    dataOptions={contatoOptions}
                    disabled={disabled}
                    control={control}
                    dataName="ContatoId"
                  />
                }
              </label>
              <label htmlFor="VendedorProgenie" className="mt-5">
                Vendedor Progenie
                {contatoOptions.length &&
                  <AutoComplete 
                    dataOptions={contatoOptions}
                    disabled={disabled}
                    control={control}
                    dataName="VendedorProgenieContatoId"
                  />
                }
              </label>
              <label htmlFor="Condicoes" className="mt-[1.1rem]">
                Condições
                <input
                  type="text"
                  {...register("Condicoes")}
                  name="Condicoes"
                  disabled={disabled}
                  maxLength={25}
                  className="input-login-style w-[22.9rem] disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]"
                  pattern="[a-zA-Z0-9]+"
                />
              </label>
            </div>
            <div className="flex flex-col">
              <label htmlFor="Numero">
                Nº Nota Fiscal<span className="text-error">*</span>
                <input
                  type="number"
                  {...register("Numero", { required: true })}
                  name="Numero"
                  disabled={disabled}
                  maxLength={10}
                  className={`input-login-style w-[16rem] mb-5 ${errors?.Numero && 'focus:outline-none focus:ring-2 focus:ring-error'} appearance-textfield-none disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3] placeholder:text-gray-300`}
                />
              </label>

              <label htmlFor="ValorTotalNotaReais">
                Valor Total da Nota<span className="text-error">*</span>
                <Field
                  control={control}
                  name="ValorTotalNotaReais"
                  render={({ field }) => (
                    <InputMoney
                      disabled={disabled}
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="Valor unitário"
                      className={`input-login-style w-[16rem] h-[2.4rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]`}
                    />
                  )}
                />
              </label>

              <div className=" flex gap-3">
                <label htmlFor="ComissaoPorcentagem">
                  Comissão
                  <input
                    type="number"
                    {...register("ComissaoPorcentagem")}
                    name="ComissaoPorcentagem"
                    disabled={disabled}
                    maxLength={3}
                    className={`input-login-style w-[6rem] mb-5 ${errors?.ComissaoPorcentagem && 'focus:outline-none focus:ring-2 focus:ring-error'} disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3] placeholder:text-gray-300`}
                  />
                </label>

                <label htmlFor="NotaFiscalData">
                  Data da Nota Fiscal<span className="text-error">*</span>
                  <Field
                    control={control}
                    rules={{ required: true }}
                    name="NotaFiscalData"
                    render={({ field }) => (
                      <input
                        type="date"
                        placeholder={"Data da nota fiscal"}
                        className={`input-login-style w-[9.2rem] h-[2.4rem] mb-5 ${errors?.NotaFiscalData && 'focus:outline-none focus:ring-2 focus:ring-error'} disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]`}
                        disabled={disabled}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    )}
                  />
                </label>

              </div>
            </div>
          </div>
          <span className="absolute text-error">Campos com * são obrigatórios</span>
        </>
      }
    </form>
  );
}
